import React, { useState } from "react";
import { Container, Card, Form, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { AuthService } from "../services/AuthService";
import { FaEye, FaEyeSlash } from "react-icons/fa";

function ForgotPassword() {

    const navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [step, setStep] = useState(1);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const handleVerifyEmail = async (e) => {
        e.preventDefault();

        try {

            const data = await AuthService.verifyEmail(email);

            if (data.success) {
                setStep(2);
            }

        } catch (err) {
            alert("Email not found");
        }
    };

    const handleResetPassword = async (e) => {
        e.preventDefault();

        if (password !== confirmPassword) {
            alert("Passwords do not match");
            return;
        }

        try {

            const data = await AuthService.resetPassword(email, password);

            if (data.success) {
                alert("Password reset successful");
                navigate("/");
            }

        } catch (err) {
            alert("Error resetting password");
        }
    };

    return (
        <Container className="d-flex justify-content-center align-items-center vh-100">

            <Card style={{ width: "400px", padding: "20px" }}>

                <h4 className="text-center mb-4">Forgot Password</h4>

                {step === 1 && (

                    <Form onSubmit={handleVerifyEmail}>

                        <Form.Group className="mb-3">
                            <Form.Label>Email</Form.Label>

                            <Form.Control
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </Form.Group>

                        <Button type="submit" className="w-100">
                            Verify Email
                        </Button>

                    </Form>

                )}

                {step === 2 && (

                    <Form onSubmit={handleResetPassword}>

                        <Form.Group className="mb-3">
                            <Form.Label>New Password</Form.Label>

                            <div style={{ position: "relative" }}>

                                <Form.Control
                                    type={showPassword ? "text" : "password"}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                    style={{ paddingRight: "40px" }}
                                />

                                <span
                                    onClick={() => setShowPassword(!showPassword)}
                                    style={{
                                        position: "absolute",
                                        right: "12px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        cursor: "pointer",
                                        color: "#666"
                                    }}
                                >
                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                </span>

                            </div>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Confirm Password</Form.Label>

                            <div style={{ position: "relative" }}>

                                <Form.Control
                                    type={showConfirmPassword ? "text" : "password"}
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    required
                                    style={{ paddingRight: "40px" }}
                                />

                                <span
                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                    style={{
                                        position: "absolute",
                                        right: "12px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        cursor: "pointer",
                                        color: "#666"
                                    }}
                                >
                                    {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                                </span>

                            </div>
                        </Form.Group>

                        <Button type="submit" className="w-100">
                            Reset Password
                        </Button>

                    </Form>

                )}

            </Card>

        </Container>
    );
}

export default ForgotPassword;